"use client";
import Hyperlink from "../ui/hyperlink";
import Image from "next/image";
const Hero = () => {
    return (
        <>
            <style jsx>{`
                @keyframes rotate {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
                
                .hero-rotating-image {
                    animation: rotate 30s linear infinite;
                }
                
                .hero-image-blur-mask {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    pointer-events: none;
                }
                
                .hero-content-section {
                    position: relative;
                    border-radius: 12px;
                    padding: 20px;
                    margin-right: 20px;
                }
                
                .hero-content-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    backdrop-filter: blur(1.5px);
                    background: rgba(255, 255, 255, 0.03);
                    border-radius: 12px;
                    z-index: -1;
                    mask: radial-gradient(ellipse 100% 100% at center, black 30%, transparent 100%);
                    -webkit-mask: radial-gradient(ellipse 100% 100% at center, black 30%, transparent 100%);
                }
                
                @media (max-width: 1024px) {
                    .hero-content-section {
                        width: 80% !important;
                        max-width: 80% !important;
                    }
                }
                
                @media (max-width: 991.98px) {
                    .hero-custom-layout {
                        min-height: auto !important;
                        padding: 60px 0 !important;
                    }
                    
                    .hero-content-section {
                        width: 90% !important;
                        max-width: 90% !important;
                        position: relative !important;
                        border-radius: 0 !important;
                        padding: 0 !important;
                        margin-right: 0 !important;
                    }
                    
                    .hero-content-section::before {
                        border-radius: 0 !important;
                        mask: radial-gradient(ellipse 100% 100% at center, black 60%, transparent 85%) !important;
                        -webkit-mask: radial-gradient(ellipse 100% 100% at center, black 60%, transparent 85%) !important;
                    }
                        
                }
                @media (max-width: 575.98px) {
                    .hero-content-section {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    
                    .hero-content-section::before {
                        backdrop-filter: blur(1px) !important;
                        mask: radial-gradient(ellipse 100% 100% at center, black 70%, transparent 90%) !important;
                        -webkit-mask: radial-gradient(ellipse 100% 100% at center, black 70%, transparent 90%) !important;
                    }
                        .hero-image-section {
                            right: 0 !important;
                            width: 100% !important;
                            top: 50% !important;

                        }
                }
            `}</style>
            <section
                className=" bg-color-gradient desilo-hero2-section"
            // data-bg-src="images/hero/hero2-bg.png"
            >
                <div className="container custom-container ">
                    <div className="hero-custom-layout" style={{
                        position: 'relative',
                        minHeight: '80vh',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        {/* Content Section - 70% width, left aligned */}
                        <div className="hero-content-section" style={{
                            width: '80%',
                            maxWidth: '80%',
                            zIndex: 2,
                            position: 'relative'
                        }}>
                            <div className="hero2-content desilo-hero5__info">
                                <h1 className="text-color-primary">
                                    Creator-Economy Tech Partner
                                </h1>
                                <p className="hero2-content-text text-color-primary">
                                    Desilo builds creator-centric products that earn trust and create impact. You get clarity, momentum, and owned growth.
                                </p>
                                <Hyperlink
                                    href="https://calendly.com/parthik/30min"
                                    variant="primary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Book a consultation call
                                </Hyperlink>
                            </div>
                        </div>

                        {/* Image Section - Background, right aligned, 50% cover */}
                        <div className="hero-image-section d-block" style={{
                            position: 'absolute',
                            top: '40%',
                            right: '-45%',
                            transform: 'translateY(-50%)',
                            width: '90%',
                            height: '100vh',
                            zIndex: 1,
                            overflow: 'hidden'
                        }}>
                            <div className="hero-image-wrapper" style={{
                                position: 'relative',
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <Image
                                    src="/images/hero/Circle-bg.webp"
                                    alt="hero"
                                    width={900}
                                    height={900}
                                    loading="eager"
                                    priority
                                    fetchPriority="high"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        objectPosition: 'center',
                                        animation: 'rotate 30s linear infinite'
                                    }}
                                    className="hero-rotating-image d-sm-block d-none"
                                />
                                <Image
                                    src="/images/hero/Circle-mobile-bg.png"
                                    alt="hero"
                                    priority
                                    loading="eager"
                                    width={900}
                                    height={900}
                                    fetchPriority="high"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        objectPosition: 'center',
                                        // animation: 'rotate 30s linear infinite'
                                    }}
                                    className="hero-rotating-image d-sm-none d-block"
                                />
                                {/* Blur mask overlay */}
                                <div className="hero-image-blur-mask"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Hero;
